// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CssController from "./core/css_controller"
application.register("css", CssController)

import TextController from "./core/text_controller"
application.register("text", TextController)

import FieldController from "./core/field_controller"
application.register("field", FieldController)

import FormController from "./core/form_controller"
application.register("form", FormController)

import DateRangeFormController from "./core/form/date_range_form_controller"
application.register("date-range-form", DateRangeFormController)

import ClipboardController from "./core/clipboard_controller"
application.register("clipboard", ClipboardController)

import ComboboxController from "./core/combobox_controller.js"
application.register("combobox", ComboboxController)

import TurboStreamFrameController from "./core/turbo_stream_frame_controller.js"
application.register("turbo-stream-frame", TurboStreamFrameController)

import LightboxController from "./core/lightbox_controller.js"
application.register("lightbox", LightboxController)

import TurboFramePollController from "./core/turbo_frame_poll_controller.js"
application.register("turbo-frame-poll", TurboFramePollController)

import AccordionController from "./flowbite/accordion_controller"
application.register("accordion", AccordionController)

import CarouselController from "./flowbite/carousel_controller"
application.register("carousel", CarouselController)

import DateRangePickerController from "./flowbite/date_range_picker_controller"
application.register("date-range-picker", DateRangePickerController)

import DismissController from "./flowbite/dismiss_controller"
application.register("dismiss", DismissController)

import DrawerController from "./flowbite/drawer_controller"
application.register("drawer", DrawerController)

import DropdownController from "./flowbite/dropdown_controller"
application.register("dropdown", DropdownController)

import ModalController from "./flowbite/modal_controller"
application.register("modal", ModalController)

import PopoverController from "./flowbite/popover_controller"
application.register("popover", PopoverController)

import TabsController from "./flowbite/tabs_controller"
application.register("tabs", TabsController)

import TooltipController from "./flowbite/tooltip_controller"
application.register("tooltip", TooltipController)

import TwoFactorAuthFieldsController from "./two_factor_auth_fields_controller"
application.register("two-factor-auth-fields", TwoFactorAuthFieldsController)

import ThreatReportsController from "./threat_reports/threat_reports_controller.js"
application.register("file-uploads", ThreatReportsController)

import IntegrationSubscriptionIdentifierSelectController from "./integration_subscription/identifier_select_controller"
application.register(
  "integration-subscription-identifier-select",
  IntegrationSubscriptionIdentifierSelectController,
)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import DashboardHitsChartController from "./dashboard/hits_chart_controller"
application.register("dashboard-hits-chart", DashboardHitsChartController)

import DashboardEventsCountChartController from "./dashboard/events_count_chart_controller"
application.register(
  "dashboard-events-count-chart",
  DashboardEventsCountChartController,
)

import DashboardThreatSourcesMapController from "./dashboard/threat_sources_map_controller"
application.register(
  "dashboard-threat-sources-map",
  DashboardThreatSourcesMapController,
)

import DashboardThreatsMapController from "./dashboard/threats_map_controller"
application.register("dashboard-threats-map", DashboardThreatsMapController)

import DashboardThreatCategoriesChartController from "./dashboard/threat_categories_chart_controller"
application.register(
  "dashboard-threat-categories-chart",
  DashboardThreatCategoriesChartController,
)

import DashboardMetricConfirmationRateChartController from "./dashboard/metric/confirmation_rate_chart_controller"
application.register(
  "dashboard-metric-confirmation-rate-chart",
  DashboardMetricConfirmationRateChartController,
)

import DashboardMetricPredictionsChartController from "./dashboard/metric/predictions_chart_controller"
application.register(
  "dashboard-metric-predictions-chart",
  DashboardMetricPredictionsChartController,
)

import IocThreatChartController from "./ioc/threat_chart_controller"
application.register("ioc-threat-chart", IocThreatChartController)

import IocThreatChartCalendarController from "./ioc/threat_chart/calendar_controller"
application.register(
  "ioc-threat-chart-calendar",
  IocThreatChartCalendarController,
)

import IocEventsTimelineChartController from "./ioc/events_timeline_chart_controller"
application.register(
  "ioc-events-timeline-chart",
  IocEventsTimelineChartController,
)

import InvestigationSearchController from "./investigation/search_controller"
application.register("investigation-search", InvestigationSearchController)

import IdentifierCountriesMapController from "./identifier/countries_map_controller"
application.register(
  "identifier-countries-map",
  IdentifierCountriesMapController,
)

import IdentifierTargetedCountriesMapController from "./identifier/targeted_countries_map_controller"
application.register(
  "identifier-targeted-countries-map",
  IdentifierTargetedCountriesMapController,
)

import IdentifierTldsChartController from "./identifier/tlds_chart_controller"
application.register("identifier-tlds-chart", IdentifierTldsChartController)

import IdentifierIocsChartController from "./identifier/iocs_chart_controller"
application.register("identifier-iocs-chart", IdentifierIocsChartController)

import IocCountChartController from "./ioc/count_chart_controller"
application.register("ioc-count-chart", IocCountChartController)

import scrollController from "./scroll_controller.js"
application.register("scroll", scrollController)

import PermissionController from "./permission_controller.js"
application.register("permission", PermissionController)

import TimelineChartController from "./echarts/timeline_chart_controller.js"
application.register("timeline-chart", TimelineChartController)

import StepperController from "./stepper_controller.js"
application.register("stepper", StepperController)

import ThreatReportsIocController from "./threat_reports/ioc_controller.js"
application.register("threat-reports-ioc", ThreatReportsIocController)

import EventsScoreRangeController from "./events/score_range_controller"
application.register("events-score-range", EventsScoreRangeController)

import EventsFilterPanelController from "./events/filter_panel_controller"
application.register("events-filter-panel", EventsFilterPanelController)

import DismissableBannerController from "./core/dismissable_banner_controller"
application.register("dismissable-banner", DismissableBannerController)
